import { render } from "./FollowupWireTransfer.vue?vue&type=template&id=01386d3e&scoped=true"
import script from "./FollowupWireTransfer.vue?vue&type=script&lang=js"
export * from "./FollowupWireTransfer.vue?vue&type=script&lang=js"

import "./FollowupWireTransfer.vue?vue&type=style&index=0&id=01386d3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01386d3e"]])

export default __exports__